"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fontsmoothing = _interopRequireDefault(require("../../theming/styles/fontsmoothing"));

var _theming = require("../../theming");

var _themeContants = require("../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NewBadge = function NewBadge(_ref) {
  var number = _ref.number,
      children = _ref.children,
      variant = _ref.variant;
  return _react["default"].createElement(NewBadgeWrapper, {
    variant: variant
  }, children, number > 0 && _react["default"].createElement(Badge, {
    number: number,
    variant: variant
  }, _react["default"].createElement("span", null, number)));
};

NewBadge.themeProps = {
  wrapper: {
    name: "NEW_BADGE_WRAPPER",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  badge: {
    name: "NEW_BADGE_BADGE",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var NewBadgeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "NewBadge__NewBadgeWrapper",
  componentId: "ipw7co-0"
})(["position:relative;display:inline-block;", ";"], (0, _theming.applyVariants)(NewBadge.themeProps.wrapper));

var Badge = _styledComponents["default"].span.withConfig({
  displayName: "NewBadge__Badge",
  componentId: "ipw7co-1"
})(["display:flex;justify-content:center;align-items:center;width:20px;height:20px;line-height:1;background:", ";border-radius:50%;text-align:center;color:", ";font-size:", ";font-weight:", ";right:-12px;bottom:-12px;position:absolute;", ";", ";"], _theming.color.warning, _theming.color.white, function (p) {
  return p.number < 99 ? "12px" : "10px";
}, _theming.fontWeight.bold, _fontsmoothing["default"], (0, _theming.applyVariants)(NewBadge.themeProps.badge));

NewBadge.propTypes = {
  number: _propTypes["default"].number.isRequired,
  children: _themeContants.commonPropTypes.children
};
var _default = NewBadge;
exports["default"] = _default;